<template>
  <div class="container-fluid mt-5">
    遠端裝置
    <div class="video-list">
      <div v-for="item in videoList"
          v-bind:video="item"
          v-bind:key="item.id"
          class="video-item">
        <video controls autoplay playsinline :ref="el => { if (el) videos.push(el) }" :height="cameraHeight" :muted="item.muted" :id="item.id" ></video>
      </div>
    </div>
    <div class="mt-4">
      我的設定
      <br>
      <button class="btn" :class="{'btn-primary': Myaudio, 'btn-danger': !Myaudio}" @click="setMyAudio">麥克風</button>
      <button class="btn btn-warning ms-2" @click="remindclass">上課提醒</button>
      <button class="btn btn-success ms-2" @click="sendquiz">即時問答</button>
    </div>
    <div class="mt-4">
      學生舉手
      <div class="card me-2" style="width: 18rem;" v-for="(item, i) in student_button" :key="i">
        <div class="card-body">
          <h5 class="card-title">學生{{i}}</h5>
          <button  class="btn btn-success" @click="clear_button(i)">收到</button>
        </div>
      </div>   
    </div>
    <div class="mt-4">
      即時問答
      <div class="card me-2 w-100" v-if="at_quiz">
        <div class="card-body">
          <h5 class="card-title mb-2">Q: 如何讓學生在遠距教學中，不再枯燥瞪著螢幕？</h5>
          <div class="d-flex align-items-center" v-if="Object.keys(quiz_data).length == 0">
            <div class="spinner-border text-secondary" role="status">
              <span class="visually-hidden">等待搶答</span>
            </div>
            <h6 class="text-secondary m-0 ms-1">等待搶答</h6>
          </div>
          <div v-if="Object.keys(quiz_data).length > 0">
            <div class="d-flex align-items-center mb-3">
              <div class="spinner-grow text-primary" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
              <h6 class="m-0 ms-1">學生{{quiz_data.name}}搶答</h6>
            </div>
            <button  class="btn btn-secondary" @click="quizfeedback(false)">再接再勵</button>
            <button class="btn btn-success ms-1" @click="quizfeedback(true)">好棒</button>
          </div>
        </div>
      </div>   
    </div>
  </div>
</template>

<script>
  const io = require("socket.io-client");
  const SimpleSignalClient = require('simple-signal-client');

  export default {
    name: 'TestInClass',
    components: {
    },
    beforeUpdate() {
      this.videos = []
    },
    data() {
      return {
        signalClient: null,
        localStream: null,
        videoList: [],
        canvas: null,
        socket: null,
        videos: [],
        Myaudio: true,
        student_button: [],
        at_quiz: false,
        quiz_data: {},
      };
    },
    props: {
      roomId: {
        type: String,
        default: 'public-room-v2'
      },
      socketURL: {
        type: String,
        default: 'https://docker.yushan.tw'
        //default: 'https://localhost:3000'
        //default: 'https://192.168.1.201:3000'
      },
      cameraHeight: {
        type: [Number, String],
        default: 160
      },
      autoplay: {
        type: Boolean,
        default: true
      },
      screenshotFormat: {
        type: String,
        default: 'image/jpeg'
      },
      enableAudio: {
        type: Boolean,
        default: true
      },
      enableVideo: {
        type: Boolean,
        default: true
      },
      enableLogs: {
        type: Boolean,
        default: true
      },
      peerOptions: {
        type: Object,  // NOTE: use these options: https://github.com/feross/simple-peer
        default() {
          return {};
        }
      },
      deviceId: {
        type: String,
        default: null
      }
    },
    watch: {
    },
    mounted() {
      this.join()
    },
    methods: {
      async join() {
        var that = this;
        this.log('join');
        this.socket = io.connect(this.socketURL, {path: "/socket/socket.io/" ,rejectUnauthorized: false, transports: ['websocket'] });
        this.syncdata = setInterval(this.get_student_button, 1000)
        this.signalClient = new SimpleSignalClient(this.socket);
        let constraints = {
          video: that.enableVideo,
          audio: that.enableAudio
        };
        if (that.deviceId && that.enableVideo) {
          constraints.video = { deviceId: { exact: that.deviceId } };
        }
        try {
          this.localStream = await navigator.mediaDevices.getUserMedia(constraints); 
          this.log('opened', this.localStream);
        } catch (error) {
          this.localStream = {id: 'no_mic_device'}
        }
        this.joinedRoom(this.localStream, true);
        this.signalClient.once('discover', (discoveryData) => {
          that.log('discovered', discoveryData)
          async function connectToPeer(peerID) {
            if (peerID == that.socket.id) return;
            try {
              that.log('Connecting to peer');
              const { peer } = await that.signalClient.connect(peerID, that.roomId, that.peerOptions);
              that.videoList.forEach(v => {
                if (v.isLocal) {
                  that.onPeer(peer, v.stream);
                }
              })
            } catch (e) {
              that.log('Error connecting to peer');
            }
          }
          discoveryData.peers.forEach((peerID) => connectToPeer(peerID));
          that.$emit('opened-room', that.roomId);
        });
        this.signalClient.on('request', async (request) => {
          that.log('requested', request)
          const { peer } = await request.accept({}, that.peerOptions)
          that.log('accepted', peer);
          that.videoList.forEach(v => {
            if (v.isLocal) {
              that.onPeer(peer, v.stream);
            }
          })
        })
        this.signalClient.discover(that.roomId);
        this.socket.on('get_button', data => {
          console.log('get button')
          //console.log(data)
          that.student_button = data
        })
        this.socket.on('student_want_answer', data => {
          console.log('get student want answer')
          //console.log(data)
          that.quiz_data = {}
          that.quiz_data.name = data
        })
       
      },
      onPeer(peer, localStream) {
        var that = this;
        that.log('onPeer');
        console.log(localStream)
        if(localStream.id != "no_mic_device"){
          peer.addStream(localStream);
        }
        peer.on('stream', (remoteStream) => {
          that.joinedRoom(remoteStream, false);
          peer.on('close', () => {
            var newList = [];
            that.videoList.forEach(function (item) {
              if (item.id !== remoteStream.id) {
                newList.push(item);
              }
            });
            that.videoList = newList;
            that.$emit('left-room', remoteStream.id);
          });
          peer.on('error', (err) => {
            that.log('peer error ', err);
          });
        });
      },
      joinedRoom(stream, isLocal) {
        var that = this;
        let found = that.videoList.find(video => {
          return video.id === stream.id
        })

        if (found === undefined) {
          let video = {
            id: stream.id,
            muted: isLocal,
            stream: stream,
            isLocal: isLocal
          };

          that.videoList.push(video);
        }

        setTimeout(function () {
          for (var i = 0, len = that.videos.length; i < len; i++) {
            if (that.videos[i].id === stream.id && stream.id != "no_mic_device") {
              that.videos[i].srcObject = stream;
              break;
            }
          }
        }, 500);
        

        that.$emit('joined-room', stream.id);
      },
      leave() {
        this.videoList.forEach(v => {
          try{
            v.stream.getTracks().forEach(t => t.stop())
          }
          catch(error){

          }
        });
        this.videoList = [];
        this.signalClient.peers().forEach(peer => peer.removeAllListeners())
        this.signalClient.destroy();
        this.signalClient = null;
        this.socket.destroy();
        this.socket = null;
      },
      capture() {
        return this.getCanvas().toDataURL(this.screenshotFormat);
      },
      getCanvas() {
        let video = this.videos[0];
        if (video !== null && !this.ctx) {
          let canvas = document.createElement('canvas');
          canvas.height = video.clientHeight;
          canvas.width = video.clientWidth;
          this.canvas = canvas;
          this.ctx = canvas.getContext('2d');
        }
        const { ctx, canvas } = this;
        ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
        return canvas;
      },
      async shareScreen() {
        var that = this;
        if (navigator.mediaDevices == undefined) {
          that.log('Error: https is required to load cameras');
          return;
        }

        try {
          var screenStream = await navigator.mediaDevices.getDisplayMedia({ video: true, audio: false });
          this.joinedRoom(screenStream, true);
          that.$emit('share-started', screenStream.id);
          that.signalClient.peers().forEach(p => that.onPeer(p, screenStream));
        } catch (e) {
          that.log('Media error: ' + JSON.stringify(e));
        }
      },
      log(message, data) {
        if (this.enableLogs) {
          console.log(message);
          if (data != null) {
            console.log(data);
          }
        }
      },
      setMyAudio(){
        this.Myaudio = !this.Myaudio
        this.localStream.getAudioTracks()[0].enabled = this.Myaudio
      },
      get_student_button(){
        const r = this.socket.emit('get_button', true)
      },
      clear_button(i){
        this.socket.emit('clear_button', i)
        console.log('清除', i)
      },
      remindclass(){
        this.socket.emit('remindclass', 123)
        alert('已提醒同學們')
      },
      sendquiz(){
        this.socket.emit('sendquiz', 123)
        this.at_quiz = true
        
      },
      quizfeedback(answer){
        this.socket.emit('quizfeedback', answer)
        this.at_quiz = false
        this.quiz_data = {}
      }
    },
    async beforeRouteLeave (to, from , next) {
      const answer = await window.confirm('您要離開教室嗎')
      if (answer) {
        clearInterval(this.syncdata)
        this.leave()
        next()
      } else {
        next(false)
      }
    }

  };
</script>
<style scoped>
  .video-list {
    background: whitesmoke;
    height: auto;
    display: flex;
    flex-direction: row;
    justify-content: center;
    flex-wrap: wrap;
  }

    .video-list div {
      padding: 0px;
    }

  .video-item {
    background: #c5c4c4;
    display: inline-block;
  }
</style>
